import {
  Chart as ChartJS,
  ArcElement,
  BarElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler,
} from "chart.js";

import "./DashboardData.scss";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";

import PdfExportStats from "./PdfExportStats";
import UsersPerCountryStats from "./UsersPerCountryStats";
import RegistartionsPerMonthStats from "./RegistrationsPerMonthStats";
import LoginsPerMonthNettoStats from "./LoginsPerMonthNettoStats";
import LoginsPerMonthBruttoStats from "./LoginsPerMonthBruttoStats";
import LoginsPerMonthDurationStats from "./LoginsPerMonthDurationStats";
import GeoBimDownloadsStats from "./GeoBimDownloadsStats";
import WordExportStats from "./WordExportStats";
import { ToastContainer } from "react-toastify";
import DownloadAll from "./DownloadAll";
import KpiCards from "./KpiCards";
import { applyChartDefaults } from "./chartTheme";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  BarElement,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Filler
);

applyChartDefaults();

const Section = ({ title, children }) => (
  <section className="dashboard-section">
    <h2 className="dashboard-section__title">{title}</h2>
    <Row className="g-4">{children}</Row>
  </section>
);

const DashboarData = () => {
  const { t } = useTranslation(["translation", "statistics"]);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
      />
      <div className="DashboardData">
        <div className="container-fluid">
          <div className="dashboard-hero bg-light rounded mt-3 d-flex flex-wrap justify-content-between align-items-center gap-3">
            <div>
              <h1>{t("general.title", { ns: "statistics" })}</h1>
              <p className="lead mb-0">{t("general.subText", { ns: "statistics" })}</p>
            </div>
            <DownloadAll />
          </div>

          <KpiCards />

          <Section title={t("user.title", { ns: "statistics" })}>
            <Col md={12} xl={7}>
              <RegistartionsPerMonthStats />
            </Col>
            <Col md={12} xl={5}>
              <UsersPerCountryStats />
            </Col>
          </Section>

          <Section title={t("sections.activity", { ns: "statistics" })}>
            <Col md={6}>
              <LoginsPerMonthNettoStats />
            </Col>
            <Col md={6}>
              <LoginsPerMonthBruttoStats />
            </Col>
            <Col md={12}>
              <LoginsPerMonthDurationStats />
            </Col>
          </Section>

          <Section title={t("sections.exports", { ns: "statistics" })}>
            <Col md={6}>
              <PdfExportStats />
            </Col>
            <Col md={6}>
              <GeoBimDownloadsStats />
            </Col>
            <Col md={12}>
              <WordExportStats />
            </Col>
          </Section>
        </div>
      </div>
    </>
  );
};

export default DashboarData;
